import React from 'react'

const About = () => {
    return (
        <section className="section about-section">
            <h1 className="section-title">about us</h1>
            <p>
                {/* lorem40 */}
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quam repudiandae ipsa tempora voluptatibus, natus numquam officiis doloremque cumque et fugiat neque enim nemo ad error aperiam minima rem fuga eos mollitia debitis minus. Saepe cum alias repudiandae quaerat voluptatum labore?
            </p>
        </section>
)
}

export default About;